import React from 'react';
import { CheckCircle, Mail, Plane } from 'lucide-react';
import Reveal from './Reveal';
import './HowItWorks.css';

const STEPS = [
  {
    icon: CheckCircle,
    title: 'Pick your bundle',
    body: "Takes about a minute. You've done harder things.",
  },
  {
    icon: Mail,
    title: 'Check your inbox',
    body: 'Your eSIM QR code lands instantly. Your lounge pass follows in a separate email from our partner Lounge Pass.',
  },
  {
    icon: Plane,
    title: "Travel like you planned this months ago",
    body: "Scan, sip, scroll. You're set.",
  },
];

export default function HowItWorks() {
  return (
    <section className="tp-how container">
      <h2 className="headline-2 tp-how__title">How it works</h2>
      <div className="tp-how__steps">
        {STEPS.map(({ icon: Icon, title, body }, i) => (
          <Reveal key={title} as="div" delay={i * 60} className="tp-how__step">
            <div className="tile tp-how__tile">
              <Icon size={32} strokeWidth={1.5} color="var(--primary-60)" />
            </div>
            <h3 className="title-m">{title}</h3>
            <p className="body-s tp-how__body">{body}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
